import { Packet } from "../Interfaces/commonDtos";
import {
  IPortfolioAggregateSearchParams,
  IPortfolioAggregateTableReport,
  IPortfolioInsTableReport,
  IPortfolioInsTableSearchParams,
  IPortfolioSearchParams,
  IPortfolioTableReport,
  IDailyPortfoGraphDTO,
  IHourlyPortfoValueGraphDTO,
  IDropdownItem,
  IWalletSearchParams,
  IWalletTableReport,
  ILiquidityManagementSearchParams,
  ILiquidityManagementTableReport,
  ILiquidityManagementRecordsSearchParams,
  ILiquidityManagementRecordsTableReport,
  ICreateWallet,
  IUserWalletsInfo,
  ITransferResult,
  IGeneralViewSearchParams,
  IGeneralViewTableReport,
  IAssetPercentageSearchParams,
  IAssetPercentageTableReport,
  IMarginSearchParams,
  IMarginTableReport,
  IMarginConfig,
  IShortCoveredCallSearchParams,
  IShortCoveredCallTableReport,
  ICoveredSummarySearchParams,
  ICoveredSummaryTableReport,
  ICoveredSummaryDetailSearchParams,
  ICoveredSummaryDetailTableReport,
  IUserPositionSummarySearchParams,
  IUserPositionSummaryTableReport,
  ITable2TableReport,
  ITable2SearchParams,
  BaseAssetVolumeConfig,
  RealBaseAssetVolumeConfig,
  CashFlowTableReport,
  CashFlowSearchParams,
  CreateAccountSearchParams,
  CreateAccountsTableReport,
  ILiquidityManagementConfig,
  ILiquidityManagementTask,
  IMwrPeriodReturnGraph,
  IInvestmentReturnSearchParams,
  IInvestmentReturnTableReport,
  ExcludedCalculationSymbolSearchParams,
  ExcludedCalculationSymbolTableReport,
} from "../Interfaces/imePortfolio";
import { User } from "../Interfaces/connections";
import { Report } from "../Interfaces/TableInterfaces";
import {
  downloadExcel,
  getTable,
  postRequest,
  getRequest,
  putRequest,
  deleteRequest,
  postDownloadExcel,
} from "./requestTemplates";
import { Graph_Dto } from "src/Interfaces/orderbookGraphInterfaces";
import { isCustomerUser } from "../helper";

const getImeApiPrefix = () =>
  isCustomerUser() ? "/v1/CustomerReport" : "/v1/IME";

export interface FileResponse {
  blob: Blob;
  filename: string;
}

export const getPortfoExcelFile = () => {
  const rand = Math.random();
  return downloadExcel(`${getImeApiPrefix()}/GetActiveUsersPortfoliosExcelFile?${rand}`);
};

export const getPortfolioAggregaateTable = (
  searchParam: IPortfolioAggregateSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IPortfolioAggregateTableReport>> =>
  getTable<IPortfolioAggregateSearchParams, IPortfolioAggregateTableReport>(
    `${getImeApiPrefix()}/GetActiveUsersPortfolioSummary`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const getPortfolioTable = (
  searchParam: IPortfolioSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IPortfolioTableReport>> =>
  getTable<IPortfolioSearchParams, IPortfolioTableReport>(
    `${getImeApiPrefix()}/GetActiveUsersPortfolioInfo`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const getPortfolioInsTable = (
  searchParam: IPortfolioInsTableSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IPortfolioInsTableReport>> =>
  getTable<IPortfolioSearchParams, IPortfolioInsTableReport>(
    `${getImeApiPrefix()}/GetActiveUsersPortfolioInfoInstrument`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );
export const portfoForceUpdate = (): Promise<Packet<boolean>> =>
  postRequest(`${getImeApiPrefix()}/forceUpdate`, {});

export const getDailyPortfoGraph = (
  dto: IDailyPortfoGraphDTO,
): Promise<Graph_Dto[]> => postRequest(`${getImeApiPrefix()}/DailyPortfoValueGraph`, dto);

export const getHourlyPortfoValueGraph = (
  dto: IHourlyPortfoValueGraphDTO,
): Promise<Graph_Dto[]> => postRequest(`${getImeApiPrefix()}/HourlyPortfoValueGraph`, dto);

export const getUsers = (): Promise<Array<User>> =>
  getRequest("/v1/connection/getUsers?exchangeType=1");

export const getStepInstruments = (): Promise<IDropdownItem[]> =>
  getRequest(`${getImeApiPrefix()}/GetActiveUsersPortfolioInstrumentDropdown`);
//-------------------------------Portfo----------------------------

/**
 * ime portfolio => Portfo
 * دراپ داون نماد پایه در تنظیمات
 *
 * @async
 * @version 1.4.0
 */
export const getٰVolumeAssetDropdown = (): Promise<IDropdownItem[]> =>
  getRequest(`${getImeApiPrefix()}/GetBaseAssetVolumeIdNameList`);

/**
 * ime portfolio => Portfo
 * گرفتن لیست
 *
 * @async
 * @version 1.4.0
 */
export const getRealBaseAssetVolumeConfig =
  (): Promise<RealBaseAssetVolumeConfig> =>
    getRequest(`${getImeApiPrefix()}/GetRealBaseAssetVolumeConfig`);
/**
 * Market Watch => Portfo
 * ثبت
 *
 * @param {BaseAssetVolumeConfig} data
 * @async
 * @version 1.4.0
 */
export const addBaseAssetVolume = (data: BaseAssetVolumeConfig): Promise<any> =>
  postRequest(`${getImeApiPrefix()}/AddBaseAssetVolumeConfig`, data);

/**
 * Market Watch => IME => underlying assets
 * حذف نماد پایه
 *
 * @param {string} id
 * @async
 * @version 1.4.0
 */
export const deleteBaseAssetValue = (
  ticker: string,
): Promise<Packet<boolean>> =>
  deleteRequest(`${getImeApiPrefix()}/RemoveBaseAssetVolumeConfig?ticker=${ticker}`);

/**
 * ime portfolio => Portfo
 * جدول ۱
 *
 * @param {IUserPositionSummarySearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getPortfoAssetValueTable = (
  searchParam: IUserPositionSummarySearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IUserPositionSummaryTableReport>> =>
  getTable<IUserPositionSummarySearchParams, IUserPositionSummaryTableReport>(
    `${getImeApiPrefix()}/PortfoAssetValue`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * ime portfolio => Portfo
 * جدول ۱ اکسل
 *
 * @param {number} userId
 * @async
 * @version 1.4.0
 */
export const getPortfoAssetValueExcelFile = (userId: number) => {
  const rand = Math.random();
  return postDownloadExcel(`${getImeApiPrefix()}/PortfoAssetValueExcel?${rand}`, { userId });
};

/**
 * ime portfolio => Portfo
 * تسهیم سبد بر مبنای دارایی پایه
 *
 * @param {IUserPositionSummarySearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const geBasketPercentageBasedOnAssets = (
  searchParam: IUserPositionSummarySearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IUserPositionSummaryTableReport>> =>
  getTable<IUserPositionSummarySearchParams, IUserPositionSummaryTableReport>(
    `${getImeApiPrefix()}/BaseAssetAllocation`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );
/**
 * ime portfolio => Portfo
 *  خالص ارزش روز دارایی‌ها
 *
 * @param {IUserPositionSummarySearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const gePureAssetValue = (
  searchParam: IUserPositionSummarySearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IUserPositionSummaryTableReport>> =>
  getTable<IUserPositionSummarySearchParams, IUserPositionSummaryTableReport>(
    `${getImeApiPrefix()}/NetAssetValue`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );
/**
 * ime portfolio => Portfo
 *    وضعیت نقدینگی و مارجین
 *
 * @param {IUserPositionSummarySearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const geMarginStatus = (
  searchParam: IUserPositionSummarySearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IUserPositionSummaryTableReport>> =>
  getTable<IUserPositionSummarySearchParams, IUserPositionSummaryTableReport>(
    `${getImeApiPrefix()}/LiquidityMarginStatus`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );
/**
 * ime portfolio => Portfo
 *  اکسپوژر گواهی سپرده شمش طلا
 *
 * @param {IUserPositionSummarySearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const geGoldCertificateExposure = (
  searchParam: IUserPositionSummarySearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IUserPositionSummaryTableReport>> =>
  getTable<IUserPositionSummarySearchParams, IUserPositionSummaryTableReport>(
    `${getImeApiPrefix()}/GoldBarDepositExposure`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );
/**
 * ime portfolio => Portfo
 *  مانده حساب
 *
 * @param {IUserPositionSummarySearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const geAccountBalance = (
  searchParam: IUserPositionSummarySearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IUserPositionSummaryTableReport>> =>
  getTable<IUserPositionSummarySearchParams, IUserPositionSummaryTableReport>(
    `${getImeApiPrefix()}/AccountBalance`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * ime portfolio => Portfo
 * جدول خلاصه پوزیشن‌ها۱
 *
 * @param {ITable2SearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const geUserPositionSummaryTable = (
  searchParam: ITable2SearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<ITable2TableReport>> =>
  getTable<ITable2SearchParams, ITable2TableReport>(
    `${getImeApiPrefix()}/UserPositionSummary`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * ime portfolio => Portfo
 * جدول پوزیشن اکسل
 *
 * @param {ITable2SearchParams} searchParam
 * @async
 * @version 1.4.0
 */
export const getUserPositionExcelFile = (searchParam: ITable2SearchParams) => {
  const rand = Math.random();
  return postDownloadExcel(
    `${getImeApiPrefix()}/UserPositionSummaryExcel?${rand}`,
    searchParam,
  );
};
/**
 * ime portfolio => Portfo
 * تبدیل به گواهی سپرده شمش طلا
 *
 * @param {ITable2SearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getConvertToGoldBarDeposit = (
  searchParam: ITable2SearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<ITable2TableReport>> =>
  getTable<ITable2SearchParams, ITable2TableReport>(
    `${getImeApiPrefix()}/GetConvertToGoldBarDepositTable`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const getConvertToGoldBarDepositExcel = (
  searchParam: ITable2SearchParams,
) => {
  const rand = Math.random();
  return postDownloadExcel(
    `${getImeApiPrefix()}/GetConvertToGoldBarDepositTableExcel?${rand}`,
    searchParam,
  );
};

/**
 * ime portfolio => Portfo
 * جدول دارایی پایه
 *
 * @param {ITable2SearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getUserBaseDetailTable = (
  searchParam: ITable2SearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<ITable2TableReport>> =>
  getTable<ITable2SearchParams, ITable2TableReport>(
    `${getImeApiPrefix()}/UserBaseDetail`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * ime portfolio => Portfo
 * جدول دارایی پایه اکسل
 *
 * @param {ITable2SearchParams} searchParam
 * @async
 * @version 1.4.0
 */
export const getUserBaseDetailExcelFile = (
  searchParam: ITable2SearchParams,
) => {
  const rand = Math.random();
  return postDownloadExcel(`${getImeApiPrefix()}/UserBaseDetailExcel?${rand}`, searchParam);
};

/**
 * ime portfolio => Portfo
 * جدول آتی
 *
 * @param {ITable2SearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getUserFutureDetailTable = (
  searchParam: ITable2SearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<ITable2TableReport>> =>
  getTable<ITable2SearchParams, ITable2TableReport>(
    `${getImeApiPrefix()}/UserFutureDetail`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * ime portfolio => Portfo
 * جدول آتی اکسل
 *
 * @param {ITable2SearchParams} searchParam
 * @async
 * @version 1.4.0
 */
export const getUserFutureDetailExcelFile = (
  searchParam: ITable2SearchParams,
) => {
  const rand = Math.random();
  return postDownloadExcel(
    `${getImeApiPrefix()}/UserFutureDetailExcel?${rand}`,
    searchParam,
  );
};

/**
 * ime portfolio => Portfo
 * جدول کال آپشن
 *
 * @param {ITable2SearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getUserCallOptionDetailTable = (
  searchParam: ITable2SearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<ITable2TableReport>> =>
  getTable<ITable2SearchParams, ITable2TableReport>(
    `${getImeApiPrefix()}/UserCallOptionDetail`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * ime portfolio => Portfo
 * جدول کال آپشن اکسل
 *
 * @param {ITable2SearchParams} searchParam
 * @async
 * @version 1.4.0
 */
export const getUserCallOptionDetailExcelFile = (
  searchParam: ITable2SearchParams,
) => {
  const rand = Math.random();
  return postDownloadExcel(
    `${getImeApiPrefix()}/UserCallOptionDetailExcel?${rand}`,
    searchParam,
  );
};

/**
 * ime portfolio => Portfo
 * دکمه‌های دارایی پایه
 *
 * @param {number} userId
 * @async
 * @version 1.4.0
 */
export const getUserBaseAssetDropdown = (
  userId?: number,
): Promise<IDropdownItem[]> =>
  getRequest(
    userId
      ? `${getImeApiPrefix()}/ImeUserBasesDropdown?userId=${userId}`
      : `${getImeApiPrefix()}/ImeUserBasesDropdown`,
  );

/**
 * ime portfolio => Portfo
 *
 * @param {IMwrPeriodReturnGraph} dto
 * @async
 * @version 1.4.0
 */
export const getMwrPeriodReturnGraph = (
  dto: IMwrPeriodReturnGraph,
): Promise<Graph_Dto[]> =>
  postRequest(`${getImeApiPrefix()}/GetIMEUserMwrPeriodReturnGraph`, dto);

/**
 * ime portfolio => Portfo
 *
 * @param {IMwrPeriodReturnGraph} dto
 * @async
 * @version 1.4.0
 */
export const getNavGraph = (dto: IMwrPeriodReturnGraph): Promise<Graph_Dto[]> =>
  postRequest(`${getImeApiPrefix()}/GetIMEUserNavGraph`, dto);
/**
 * ime portfolio => Portfo
 *
 * @param {IMwrPeriodReturnGraph} dto
 * @async
 * @version 1.4.0
 */
export const getPeriodProfitLoss = (
  dto: IMwrPeriodReturnGraph,
): Promise<Graph_Dto[]> =>
  postRequest(`${getImeApiPrefix()}/GetIMEUserPeriodProfitLossGraph`, dto);

/**
 * ime portfolio => Portfo
 *
 * @param {IMwrPeriodReturnGraph} dto
 * @async
 * @version 1.4.0
 */
export const getAnnualizedMwrReturnGraph = (
  dto: IMwrPeriodReturnGraph,
): Promise<Graph_Dto[]> =>
  postRequest(`${getImeApiPrefix()}/GetIMEUserAnnualizedMwrReturnGraph`, dto);

/**
 * ime portfolio => Portfo
 * نمادهای خارج از معاملات
 *
 * @param {IUserPositionSummarySearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getExcludedCalculationSymbolsTable = (
  searchParam: IUserPositionSummarySearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IUserPositionSummaryTableReport>> =>
  getTable<IUserPositionSummarySearchParams, IUserPositionSummaryTableReport>(
    `${getImeApiPrefix()}/IMEUserExcludedCalculationSymbols`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * ime portfolio => Portfo
 * دکمه‌های دارایی پایه
 *
 * @async
 * @version 1.4.0
 */
export const getSymbolDropdown = (): Promise<IDropdownItem[]> =>
  getRequest(`${getImeApiPrefix()}/GetInstrumentsDropdown`);

/**
 * ime portfolio => Portfo
 * ثبت
 *
 * @param {ExcludedCalculationSymbolSearchParams} params
 * @async
 * @version 1.4.0
 */
export const addSymbol = (
  params: ExcludedCalculationSymbolSearchParams,
): Promise<any> =>
  postRequest(`${getImeApiPrefix()}/CreateIMEUserExcludedCalculationSymbol`, params);

/**
 * ime portfolio => Portfo
 * گرفتن لیست جدول نمادهای خارج از محاسبات
 *
 * @param {number} userId
 * @async
 * @version 1.4.0
 */
export const getExcludedCalculationList = (
  userId: number,
): Promise<ExcludedCalculationSymbolTableReport[]> =>
  getRequest(
    `${getImeApiPrefix()}/GetIMEUserExcludedCalculationSymbolsByUserId?userId=${userId}`,
  );

/**
 * ime portfolio => Portfo
 * حذف رکورد نماد
 *
 * @param {string} id
 * @async
 * @version 1.4.0
 */
export const deleteExcludedCalculationSymbolRecord = (
  id: number,
): Promise<Packet<boolean>> =>
  deleteRequest(`${getImeApiPrefix()}/DeleteIMEUserExcludedCalculationSymbol?id=${id}`);

//-------------------------------Wallet----------------------------
/**
 * ime portfolio => wallet
 * اکانت
 *
 * @async
 * @version 1.4.0
 */
export const getWalletUsers = (): Promise<IDropdownItem[]> =>
  getRequest("/v1/connection/getUsers?exchangeType=1&status=1");

/**
 * ime portfolio => wallet
 * کیف پول مبدا و مقصد
 *
 * @async
 * @version 1.4.0
 */
export const getWallets = (): Promise<IDropdownItem[]> =>
  getRequest(`${getImeApiPrefix()}/GetWalletTypeDropDown`);

/**
 * ime portfolio => wallet
 * جدول مشخصات دارایی پایه
 *
 * @param {IWalletSearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getWalletTable = (
  searchParam: IWalletSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IWalletTableReport>> =>
  getTable<IWalletSearchParams, IWalletTableReport>(
    `${getImeApiPrefix()}/GetActiveUsersWalletTransferRequests`,
    searchParam,
    offset,
    pageSize,
    sortingType === "" ? "JalaliDate_desc" : sortingType,
  );

/**
 * ime portfolio => wallet
 * ثبت
 *
 * @param {ICreateWallet} params
 * @async
 * @version 1.4.0
 */
export const setTransfer = (
  params: ICreateWallet,
): Promise<ITransferResult[]> =>
  postRequest(`${getImeApiPrefix()}/AddUsersInternalTransfer`, { ...params, desc: "" });

/**
 * ime portfolio => wallet
 * ثبت
 *
 * @async
 * @version 1.4.0
 */
export const getUserWalletsInfo = (): Promise<IUserWalletsInfo[]> =>
  getRequest(`${getImeApiPrefix()}/GetUserWalletInfos`);

/**
 * ime portfolio => Portfo
 * گرفتن لیست جدول واریز
 *
 * @param {number} userId
 * @async
 * @version 1.4.0
 */
export const getClashFlowTable = (
  userId: number,
): Promise<CashFlowTableReport[]> =>
  getRequest(`${getImeApiPrefix()}/GetIMEUserCashFlowRecords?userId=${userId}`);

/**
 * ime portfolio => Portfo
 * حذف رکورد تاریخ
 *
 * @param {string} id
 * @async
 * @version 1.4.0
 */
export const deleteCashFlowRecord = (id: number): Promise<Packet<boolean>> =>
  deleteRequest(`${getImeApiPrefix()}/DeleteIMEUserCashFlowRecord?id=${id}`);

/**
 * ime portfolio => wallet
 * ثبت
 *
 * @param {CashFlowSearchParams} params
 * @async
 * @version 1.4.0
 */
export const addCash = (params: CashFlowSearchParams): Promise<any> =>
  postRequest(`${getImeApiPrefix()}/CreateIMEUserCashFlowRecord`, params);

/**
 * ime portfolio => Portfo
 * ثبت
 *
 * @param {CreateAccountSearchParams} params
 * @async
 * @version 1.4.0
 */
export const createAccount = (
  params: CreateAccountSearchParams,
): Promise<any> => postRequest(`${getImeApiPrefix()}/UpsertIMEUserAccountOpenInfo`, params);

/**
 * ime portfolio => Portfo
 * گرفتن لیست جدول واریز
 *
 * @param {number} userId
 * @async
 * @version 1.4.0
 */
export const getCreateAccountsTable = (
  userId: number,
): Promise<CreateAccountsTableReport> =>
  getRequest(`${getImeApiPrefix()}/GetIMEUserAccountOpenInfo?userId=${userId}`);

/**
 * ime portfolio => Portfo
 * واریز و برداشت وجه
 *
 * @param {IUserPositionSummarySearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getPaymentTable = (
  searchParam: IUserPositionSummarySearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IUserPositionSummaryTableReport>> =>
  getTable<IUserPositionSummarySearchParams, IUserPositionSummaryTableReport>(
    `${getImeApiPrefix()}/IMECashFlow`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * ime portfolio => Portfo
 * محاسبه بازده
 *
 * @param {IInvestmentReturnSearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getInvestmentTable = (
  searchParam: IInvestmentReturnSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IInvestmentReturnTableReport>> =>
  getTable<IInvestmentReturnSearchParams, IInvestmentReturnTableReport>(
    `${getImeApiPrefix()}/IMEInvestmentReturn`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * ime portfolio => Portfo
 * دریافت اطلاعات کاربر
 *
 * @param {number} userId
 * @async
 * @version 1.4.0
 */
export const portfoForceUserUpdate = (
  userId: number,
): Promise<Packet<boolean>> =>
  postRequest(`${getImeApiPrefix()}/ForceUpdateUser`, { userId });

//---------------------General View---------------------------
/**
 * ime portfolio => general view
 * نمای کلی
 *
 * @param {IGeneralViewSearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getGeneralViewTable = (
  searchParam: IGeneralViewSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IGeneralViewTableReport>> =>
  getTable<IGeneralViewSearchParams, IGeneralViewTableReport>(
    `${getImeApiPrefix()}/GeneralView`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * ime portfolio => general view
 * نمای کلی اکسل
 *
 * @async
 * @version 1.4.0
 */
export const getGeneralViewExcelFile = () => {
  const rand = Math.random();
  return postDownloadExcel(`${getImeApiPrefix()}/GeneralViewExcel?${rand}`, {});
};
//---------------------Asset Percentage---------------------------
/**
 * ime portfolio => Asset Percentage
 * تسهیم دارایی
 *
 * @param {IAssetPercentageSearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getAssetPercentageTable = (
  searchParam: IAssetPercentageSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IAssetPercentageTableReport>> =>
  getTable<IAssetPercentageSearchParams, IAssetPercentageTableReport>(
    `${getImeApiPrefix()}/AssetGeneralView`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );
/**
 * ime portfolio => general view
 *  تسهیم دارایی اکسل
 *
 * @async
 * @version 1.4.0
 */
export const getAssetPercentageExcelFile = () => {
  const rand = Math.random();
  return postDownloadExcel(`${getImeApiPrefix()}/AssetGeneralViewExcel?${rand}`, {});
};
//---------------------Margin---------------------------

/**
 * ime portfolio => Margin
 * مارجین
 *
 * @param {IAssetPercentageSearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getMarginTable = (
  searchParam: IMarginSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IMarginTableReport>> =>
  getTable<IMarginSearchParams, IMarginTableReport>(
    `${getImeApiPrefix()}/MarginSummaryView`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * ime portfolio => general view
 *   مارجین اکسل
 *
 * @async
 * @version 1.4.0
 */
export const getMarginExcelFile = () => {
  const rand = Math.random();
  return postDownloadExcel(`${getImeApiPrefix()}/MarginSummaryViewExcel?${rand}`, {});
};
/**
 * ime portfolio => Margin
 * تنظیمات مشتری
 *
 * @async
 * @version 1.4.0
 */
export const getMarginConfig = (): Promise<IMarginConfig> =>
  getRequest(`${getImeApiPrefix()}/QuickRepairConfig`);

/**
 * ime portfolio => Margin
 * ثیت تنظیمات
 *
 * @param {IMarginConfig} data
 * @async
 * @version 1.4.0
 */
export const setMarginConfig = (
  config: IMarginConfig,
): Promise<Packet<boolean>> => putRequest(`${getImeApiPrefix()}/QuickRepairConfig`, config);

//---------------------ShortCoveredCall---------------------------
/**
 * ime portfolio => ShortCoveredCall
 * خلاصه شورت‌کال
 *
 * @param {IGeneralViewSearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getShortCoveredCallTable = (
  searchParam: IShortCoveredCallSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IShortCoveredCallTableReport>> =>
  getTable<IShortCoveredCallSearchParams, IShortCoveredCallTableReport>(
    `${getImeApiPrefix()}/AggeragateCallPortfo`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * ime portfolio => ShortCoveredCall
 *  خلاصه شورت‌کال
 *
 * @async
 * @version 1.4.0
 */
export const getShortCoveredCallExcel = () => {
  const rand = Math.random();
  return postDownloadExcel(`${getImeApiPrefix()}/AggeragateCallPortfoExcel?${rand}`, {});
};

//---------------------CoveredSummary---------------------------
/**
 * ime portfolio => CoveredSummary
 * خلاصه پوشش
 *
 * @param {ICoveredSummarySearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getCoveredSummaryTable = (
  searchParam: ICoveredSummarySearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<ICoveredSummaryTableReport>> =>
  getTable<ICoveredSummarySearchParams, ICoveredSummaryTableReport>(
    `${getImeApiPrefix()}/CoverageSummary`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * ime portfolio => CoveredSummary
 * جزئیات خلاصه پوشش
 *
 * @param {ICoveredSummaryDetailSearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getCoveredSummaryDetailTable = (
  searchParam: ICoveredSummaryDetailSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<ICoveredSummaryDetailTableReport>> =>
  getTable<ICoveredSummaryDetailSearchParams, ICoveredSummaryDetailTableReport>(
    `${getImeApiPrefix()}/UserBaseSymbolCoverageSummary`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * ime portfolio => CoveredSummary
 * خلاصه پوشش اکسل
 *
 * @async
 * @version 1.4.0
 */
export const getCoveredSummaryExcelFile = () =>
  postDownloadExcel(`${getImeApiPrefix()}/CoverageSummaryExcel`, {});

//---------------------مدیریت نقدینگی-------------------------------------------
/**
 * ime portfolio => LiquidityManagement
 * تنظیمات
 *
 * @async
 * @version 1.4.0
 */
export const getLiquidityManagementConfig =
  (): Promise<ILiquidityManagementConfig> =>
    getRequest(`${getImeApiPrefix()}/GetAutomaticWalletWithdrawConfig`);

/**
 * ime portfolio => LiquidityManagement
 * ثیت تنظیمات
 *
 * @param {ILiquidityManagementConfig} data
 * @async
 * @version 1.4.0
 */
export const setLiquidityManagementConfig = (
  config: ILiquidityManagementConfig,
): Promise<Packet<boolean>> =>
  postRequest(`${getImeApiPrefix()}/SetAutomaticWalletWithdrawConfig`, config);

/**
 * ime portfolio => liquidity management
 * جدول مدیریت نقدینگی
 *
 * @param {ILiquidityManagementSearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getLiquidityManagementTable = (
  searchParam: ILiquidityManagementSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<ILiquidityManagementTableReport>> =>
  getTable<ILiquidityManagementSearchParams, ILiquidityManagementTableReport>(
    `${getImeApiPrefix()}/GetAutomaticWalletWithdrawUserTasksTable`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * ime portfolio => liquidity management
 * جدول رکوردهای مدیریت نقدینگی
 *
 * @param {ILiquidityManagementRecordsSearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getLiquidityManagementRecordsTable = (
  searchParam: ILiquidityManagementRecordsSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<ILiquidityManagementRecordsTableReport>> =>
  getTable<
    ILiquidityManagementRecordsSearchParams,
    ILiquidityManagementRecordsTableReport
  >(
    `${getImeApiPrefix()}/GetAutomaticWalletWithdrawUserTaskRecordsTable`,
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * ime portfolio => LiquidityManagement
 *  انصراف
 *
 * @param {number} id
 * @async
 * @version 1.4.0
 */
export const cancelLog = (id: number): Promise<Packet<boolean>> =>
  putRequest(`${getImeApiPrefix()}/UpdateAutomaticWalletWithdrawUserTask`, { id });

/**
 * ime portfolio => LiquidityManagement
 * اکانت
 *
 * @async
 * @version 1.4.0
 */
export const getLiquidityUsers = (): Promise<IDropdownItem[]> =>
  getRequest(`${getImeApiPrefix()}/GetAutomaticWalletWithdrawUsersDropDown`);

/**
 * ime portfolio => LiquidityManagement
 * افزودن تسک
 *
 * @param {ILiquidityManagementTask} data
 * @async
 * @version 1.4.0
 */
export const createLiquidityManagementTask = (
  config: ILiquidityManagementTask,
): Promise<Packet<boolean>> =>
  postRequest(`${getImeApiPrefix()}/CreateBulkAutomaticWalletWithdrawUserTask`, config);

/**
 * ime portfolio => LiquidityManagement
 * ویرایش تسک
 *
 * @param {ILiquidityManagementTask} data
 * @async
 * @version 1.4.0
 */
export const editLiquidityManagementTask = (
  config: ILiquidityManagementTask,
): Promise<Packet<boolean>> =>
  putRequest(`${getImeApiPrefix()}/UpdateAutomaticWalletWithdrawUserTask`, config);

/**
 * Market Watch => IME =>LiquidityManagement
 * حذف  تسک
 *
 * @param {number} taskId
 * @async
 * @version 1.4.0
 */
export const deleteLiquidityManagementTask = (
  taskId: number,
): Promise<Packet<boolean>> =>
  deleteRequest(
    `${getImeApiPrefix()}/DeleteAutomaticWalletWithdrawUserTask?taskId=${taskId}`,
  );

/**
 * Market Watch => IME =>LiquidityManagement
 * حذف تسک‌ها
 *
 * @param {ids} number[]
 * @async
 * @version 1.4.0
 */
export const bulkCancel = (ids: number[]): Promise<Packet<boolean>> =>
  putRequest(`${getImeApiPrefix()}/DeleteBulkAutomaticWalletWithdrawUserTasks`, { ids });

/**
 * Market Watch => IME => LiquidityManagement
 * عملیات گروهی -> روشن کردن برداشت اتوماتیک از اختیار
 *
 * @param {ids} number[]
 * @async
 * @version 1.4.0
 */
export const withdrawEnable = (ids: number[]): Promise<Packet<boolean>> =>
  postRequest(`${getImeApiPrefix()}/EnableAutomaticWalletAutoWithdrawBulk`, { ids });

/**
 * Market Watch => IME => LiquidityManagement
 * عملیات گروهی -> خاموش کردن برداشت اتوماتیک از اختیار
 *
 * @param {ids} number[]
 * @async
 * @version 1.4.0
 */
export const withdrawDisabled = (ids: number[]): Promise<Packet<boolean>> =>
  postRequest(`${getImeApiPrefix()}/DisableAutomaticWalletAutoWithdrawBulk`, { ids });
/**
 * Market Watch => IME => LiquidityManagement
 * درخواست برداشت
 *
 * @param {id} number
 * @async
 * @version 1.4.0
 */
export const withdrawRequest = (id: number): Promise<Packet<boolean>> =>
  postRequest(`${getImeApiPrefix()}/DoBulkAutomaticWalletWithdrawUserTask`, { id });
